Vue.asyncComponent('ak-chip', {
    props: {
        title: {
            type: String,
            default: '',
            required: false,
        },
        description: {
            type: String,
            default: '',
            required: false,
        },
        color: {
            type: String,
            required: false,
        },
        colorValue: {
            type: String,
            required: false
        },
        size: {
            type: String,
            required: false,
        },
        showClear: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
        }
    },
    computed: {
        style() {
            const style = {}

            if (this.colorValue) {
                style['--chip-background'] = this.colorValue;
            }

            if(this.textColorValue) {
                style['--chip-color'] = this.textColorValue;
            }

            return style;
        },
        textColorValue() {
            if (! this.colorValue) {
                return null;
            }

            const r = parseInt(this.colorValue.substr(1, 2), 16);
            const g = parseInt(this.colorValue.substr(3, 2), 16);
            const b = parseInt(this.colorValue.substr(5, 2), 16);
            const luminance = (0.299 * r) + (0.587 * g) + (0.114 * b);

            return luminance > 175 ? '#000000' : null;
        },
    },
    methods: {
        clearClicked() {
            this.$emit('clear');
        },
        click() {
            if (this.disabled) {
                return;
            }
            
            this.$emit('click');
        }
    }
}, 'layout/ak-chip.html');
